// Avatarul care deschide meniul pozei (Vezi / Schimbă / Șterge), pentru rândurile unde creionul din
// dreapta are altă treabă (profilul elevului: notița). Fără photo e doar avatarul. Logica pozei:
// useProfilePhoto, aceeași ca la personal. onStatus(kind, text): mesajele (ex. AlertPills la elev).
import React, { useEffect } from "react";

import { AvatarUI, DropdownUI } from "../../UI";
import useProfilePhoto from "./useProfilePhoto";

export default function ProfilePhotoAvatar({ person, color, initials, name = "", photo = null, onStatus, className = "" }) {
   const avatar = (cls) => <AvatarUI person={person} color={color} initials={initials} size={null} className={cls} />;
   const ph = useProfilePhoto(photo, { name, renderPhoto: avatar });

   useEffect(() => {
      if (ph.status.text && ph.status.kind) onStatus?.(ph.status.kind, ph.status.text);
      // doar când se schimbă mesajul
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [ph.status.kind, ph.status.text]);

   if (!ph.enabled) return avatar(`studentItem__avatar ${className}`.trim());

   return (
      // clicul pe avatar nu ajunge la rândul de dedesubt (la elev: deschiderea notiței)
      <span
         className={`profilePhotoAvatar ${className}`.trim()}
         onClick={(event) => event.stopPropagation()}
         onKeyDown={(event) => event.stopPropagation()}
      >
         <DropdownUI
            className="profilePhotoAvatar__menu"
            icon={avatar("studentItem__avatar" + (ph.busy ? " is-busy" : ""))}
            label=""
            chevrons={false}
            disabled={ph.busy}
            aria-label="Fotografia"
            options={ph.menuOptions}
            onChange={ph.onMenu}
         />
         {ph.elements}
      </span>
   );
}
